import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { doc, updateDoc, getFirestore, collection, setDoc, serverTimestamp, getDoc } from 'firebase/firestore'
import type { VueformSchema } from '@vueform/vueform';
import { useAppStateStore } from "./appState";

interface Schema extends VueformSchema {
  firestorePath: string;
  key: string;
}

export const useEditDataStore = defineStore("editData", () => {
  // states
  const title = ref("");
  const description = ref("");
  const schema = ref<Schema | null>(null);
  const firestorePath = ref("");
  const customHandleSubmit = ref<Function | null>(null);
  const previewImage = ref(null);

   // for custom edit data type
  const customEditDataType = ref('') // shipping, photobook, theme, pairEvent

  // actions
  const saveToFirestore = async (data) => {
    try {
      const docRef = doc(getFirestore(), firestorePath.value);

      await setDoc(docRef, {
        ...data,
        createdAt: serverTimestamp()
      }, { merge: true });

      alert('บันทึกสําเร็จ');
    } catch (error) {
      console.error('Error saving to Firestore:', error);
      return false;
    }
  };

  const render = () => {  
    const appStateStore = useAppStateStore();

    // desktop
    if(appStateStore?.isDesktop) {
      useRouter().push('/desktop/edit-data')
      return 
    }

    // mobile
    useRouter().push('/v3/edit-data')
  }

  return {
    firestorePath,
    schema,
    title,
    description,
    saveToFirestore,
    render,
    customHandleSubmit,
    customEditDataType,
    previewImage
  };
});
